import { createSelector } from 'reselect';

const selectCompanyRoleRestrictionsState = ({ system }) => system.companyRoleRestrictions;

export const selectCompanyRoleRestrictions = createSelector(
  selectCompanyRoleRestrictionsState,
  ({ data }) => data,
);
